import React, { useCallback, useRef, useState } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useDispatch } from "react-redux";
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from './Clients.redux';
import { useNavigate } from '@tanstack/react-router';
import DeletePopover from 'components/DeletePopover';



const ClientCell = (props) => {
	const { column, row } = props;
	const id                              = row.client_id,
		  dispatch                        = useDispatch(),
		  navigate                        = useNavigate(),
		  actionAnchor                    = useRef(null),
		  [ actionsOpen, setActionsOpen ] = useState(false);


	const beforeDeleteClient = useCallback(() => {
		dispatch(actions.setState({
			loading: true,
		}));
	}, [ dispatch ]);

	const afterDeleteClient = useCallback(() => {
		setActionsOpen(false);
		dispatch(actions.search());
	}, [ dispatch ]);


	const handleNavigate = useCallback(() => {
		navigate({ to: `/clients/view/${id}` });
	}, [ navigate, id ]);



	if(column.name === 'actions') {
		return (
			<Table.Cell
				{...props}
			>
				<Button
					variant="outlined"
					size="large"
					onClick={() => setActionsOpen(true)}
					ref={actionAnchor}
				>
					...
				</Button>
				<Menu

					open={actionsOpen}
					onClose={() => setActionsOpen(false)}
					anchorEl={actionAnchor.current}
				>
					<MenuItem>
						<DeletePopover
							objectType="CLIENT"
							objectID={id}
							afterDelete={afterDeleteClient}
							beforeDelete={beforeDeleteClient}
						>
							<Button variant="text" size="large" color="error">
								Delete Client
							</Button>
						</DeletePopover>
					</MenuItem>
				</Menu>

			</Table.Cell>
		);
	}

	return (
		<Table.Cell
			{...props}
			style={{ cursor: 'pointer' }}
			onClick={handleNavigate}
		/>
	);
};


export default ClientCell;
